export default __webpack_public_path__ + "static/media/login.7ff88b46.png";